import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import AddNewJob from "./pages/AddNewJob";
import EditJob from "./pages/EditJob";
import Home from "./pages/Home";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/add-new-job" element={<AddNewJob />} />
        <Route path="/edit-job/:jobId" element={<EditJob />} />
      </Routes>
    </Router>
  );
}

export default App;
